import http from '@/utils/http';
import env from '@/utils/env';
var api = {
    // api常量
    LOGIN_BY_SMS_API_PATH: '/v1/quick/user/login/token',
    GET_TICKET_BY_SMS_CODE_PATH: '/v3/ticket',
    GET_TICKET_API_PATH: '/v2/ticket',
    LOGIN_BY_PASSWORD_API_PATH: '/v1/ticket',
    REGISTER_API_PATH: '/v2/user/quickRegister',
    RESET_PASSWORD_API_PATH: '/v3/user/password/reset',
    GET_LOGIN_SMS_CODE_API_PATH: '/v1/sender/quickLogin',
    GET_RESET_PASSWORD_SMS_CODE_API_PATH: '/v2/sender/user/phone/current',
    GET_REGISTER_SMS_CODE_API_PATH: '/v1/sms/quickRegister',
    GET_DISTRICT_DICT_API_PATH: '/v1/dict/area',
    AUTH_API_PATH: '/v2/cert/addEnterpriseCertAndIdentity',
    GET_CERTIFICATION_API_PATH: '/v2/cert/getEnterpriseCert',
    GET_PLATFORM_LIST_API_PATH: '/v2/cert/listPlatform',
    GET_SERVICE_INFO_API_PATH: '/v2/cert/appliedPlatform',
    SUBMIT_SERVICE_INFO_API_PATH: '/v2/cert/updateIdentity',
    GET_ADDITIONAL_INFO_API_PATH: '/v2/cert/getEnterpriseAdditionalCert',
    HAS_CERT_API_PATH: '/v1/cert/hasCert',
    DOES_USER_EXIST_API_PATH: '/v1/user/doesUserExist',
    IDENTITY_STATUS_DICT_API_PATH: '/v1/dict/audit',
    CATEGORY_TREE_API_PATH: '/v2/cert/supply/category',
    GET_FACTORY_LIST: '/v1/dict/invitedEnterprises',
    UPDATE_USER_CERT: '/v2/cert/updateUserCert',
    GET_PLATFORM_LIST_BY_CERT_TYPE: '/v2/cert/listPlatformByCertType',
    // api方法
    getUploadApi: function () {
        return env.getHost(true) + "/api/v1/cert/upload?token=" + localStorage.getItem('token');
    },
    doesUserExist: function (params) {
        return http.post(api.DOES_USER_EXIST_API_PATH, params);
    },
    loginBySmsCode: function (params) {
        return http.post(api.LOGIN_BY_SMS_API_PATH, params);
    },
    getTicketBySmsCode: function (params) {
        return http.post(api.GET_TICKET_BY_SMS_CODE_PATH, params);
    },
    getTicket: function (params) {
        return http.post(api.GET_TICKET_API_PATH, params);
    },
    getToken: function (ticket, params) {
        return http.post(api.LOGIN_BY_PASSWORD_API_PATH + '/' + ticket, params);
    },
    register: function (params) {
        return http.post(api.REGISTER_API_PATH, params);
    },
    resetPassword: function (params) {
        return http.put(api.RESET_PASSWORD_API_PATH, params);
    },
    getLoginSmsCode: function (params) {
        return http.post(api.GET_LOGIN_SMS_CODE_API_PATH, params);
    },
    getResetPasswordSmsCode: function (params) {
        return http.post(api.GET_RESET_PASSWORD_SMS_CODE_API_PATH, params);
    },
    getRegisterSmsCode: function (params) {
        return http.post(api.GET_REGISTER_SMS_CODE_API_PATH, params);
    },
    getDistrictDict: function () {
        return http.post(api.GET_DISTRICT_DICT_API_PATH, {}, true);
    },
    authenticate: function (params) {
        return http.post(api.AUTH_API_PATH, params, true);
    },
    getCertificationInfo: function (params) {
        return http.post(api.GET_CERTIFICATION_API_PATH, params, true);
    },
    getPlatformList: function () {
        return http.post(api.GET_PLATFORM_LIST_API_PATH, {}, true);
    },
    /**
     * 【资质】- 已申请平台（包括平台角色列表）
     * @param {*} params
     * @returns {Promise<any>}
     */
    getServiceInfo: function (params) {
        if (params === void 0) { params = {}; }
        return http.post(api.GET_SERVICE_INFO_API_PATH, params, true);
    },
    submitServiceInfo: function (params) {
        return http.post(api.SUBMIT_SERVICE_INFO_API_PATH, params, true);
    },
    getAdditionalInfo: function () {
        return http.post(api.GET_ADDITIONAL_INFO_API_PATH, {}, true);
    },
    checkCertStatus: function () {
        return http.post(api.HAS_CERT_API_PATH, {}, true);
    },
    getIdentityStatus: function () {
        return http.post(api.IDENTITY_STATUS_DICT_API_PATH, {}, true);
    },
    getSupplyCategoryTree: function (params) {
        return http.post(api.CATEGORY_TREE_API_PATH, params, true);
    },
    getFactoryList: function (params) {
        if (params === void 0) { params = {}; }
        return http.post(api.GET_FACTORY_LIST, params, true);
    },
    updateUserCert: function (data) {
        if (data === void 0) { data = {}; }
        return http.post(api.UPDATE_USER_CERT, data, true);
    },
    getPersonalCertInfo: function (data) {
        if (data === void 0) { data = {}; }
        return http.post(env.getHost(true) + "/api/v2/cert/getIndividualCert", data);
    },
    addPersonCert: function (data) {
        return http.post(env.getHost(true) + "/api/v2/cert/addIndividualCert", data);
    },
    updatePersonCert: function (data) {
        return http.post(env.getHost(true) + "/api/v2/cert/updateIndividualCert", data);
    },
    /**
     *【资质】- 根据资质分平台列表（包括平台角色列表）
     * @param {1 | 2} certType 资质类型，1为企业，2为个人，默认为1
     * @returns {Promise<any>}
     */
    getPlatformListByCertType: function (certType) {
        if (certType === void 0) { certType = 1; }
        return http.post(env.getHost(true) + "/api" + api.GET_PLATFORM_LIST_BY_CERT_TYPE, {
            certType: certType
        });
    },
    updateCertContactInfo: function (data) {
        return http.post('/v2/cert/updateUserContactInfo', data, true);
    },
    getManufactoryTypeOptions: function () {
        return http.post('/v1/dict/manufactorType', {}, true);
    }
};
export default api;
